interface LeadFiltersProps {
  onFilterChange: (filter: FilterType) => void;
  currentFilter: FilterType;
}

export type FilterType = 'all-open' | 'unassigned' | 'recent-no-gos' | 'recently-closed';

/**
 * Lead list filter links.
 *
 * Labels match the legacy system verbatim (ManageLeads.aspx:348-350): the
 * no-go and closed views are explicitly "recent" and only cover the last
 * {@link RECENT_WINDOW_DAYS} days, rather than every no-go or closed job ever
 * recorded (Angie, Note 2).
 *
 * The "Project Manager" filter that used to sit here was removed — filtering
 * leads by PM belongs in Search, which already offers it.
 */
export function LeadFilters({ onFilterChange, currentFilter }: LeadFiltersProps) {
  const filterLinks: { id: FilterType; label: string }[] = [
    { id: 'recent-no-gos', label: "Recent No-Go's" },
    { id: 'recently-closed', label: 'Recently Closed' },
    { id: 'all-open', label: 'Open' },
    { id: 'unassigned', label: 'Unassigned' },
  ];

  return (
    <div className="flex items-center gap-1">
      {filterLinks.map((link, index) => (
        <div key={link.id} className="flex items-center">
          <button
            type="button"
            onClick={() => onFilterChange(link.id)}
            className={`px-2 py-1 text-sm transition-colors ${
              currentFilter === link.id
                ? 'text-secondary font-semibold underline'
                : 'text-gray-600 hover:text-secondary hover:underline'
            }`}
          >
            {link.label}
          </button>
          {index < filterLinks.length - 1 && (
            <span className="text-gray-400 mx-1">|</span>
          )}
        </div>
      ))}
    </div>
  );
}
